import PageError from '@zenbusiness/zui/PageError';

import { ProductsBreadcrumbs } from '#client/components/ProductsBreadcrumbs';
import useScrollTo from '#client/hooks/useScrollTo';

import { AssistanceSection } from './components/AssistanceSection';
import { BannerSection } from './components/BannerSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ExpressionSection } from './components/ExpressionSection';
import { FaqsSection } from './components/FaqsSection';
import { FootnotesSection } from './components/FootnotesSection';
import { HeroSection } from './components/HeroSection';
import { HighlightSection } from './components/HighlightSection';
import { InformationSection } from './components/InformationSection';
import { RelatedProductsSection } from './components/RelatedProductsSection';
import { ShowCaseSection } from './components/ShowCaseSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { useProductLandingContext } from './contexts/useProductLanding';
import * as Styled from './ProductLanding.style';

const ProductLanding = () => {
  const { productConfig, productId } = useProductLandingContext();

  // Scroll to top when component mounts
  useScrollTo(0, 0);

  if (!productConfig) {
    return <PageError />;
  }

  return (
    <Styled.Root>
      <ProductsBreadcrumbs productId={productId} />
      <HeroSection />
      <BannerSection />
      <ShowCaseSection />
      <ExpressionSection />
      <WhatsIncluded />
      <BenefitsSection />
      <HighlightSection />
      <InformationSection />
      <RelatedProductsSection />
      <FaqsSection />
      <FootnotesSection />
      <AssistanceSection />
    </Styled.Root>
  );
};

export default ProductLanding;
